import React from "react";
import Layout from "../components/Layout";
import styled from 'styled-components';
import bgImage from '../assets/images/sunrise-background.jpg';

const ClientStyles = styled.div`

  padding: 80px 40px 20px 40px;

  :before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0.15;
    background-image: url(${bgImage});
    background-repeat: repeat;
    background-position: 50% 0;
    background-size: cover;
    background-attachment: fixed;
  }

  h2 {
    text-align: center;
  }

  .list-wrapper {
    max-width: 800px;
    margin: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }

  .list-wrapper > ul {
    list-style: none;
  }

  .imageCredit {
    font-size: 12px;
    color: grey;
    position: absolute;
    bottom: 40px;
    width: 93%;
    text-align: center;
  }

  @media screen and (max-width: 1000px) {
    padding: 60px 20px 60px 20px;
  }

  @media screen and (max-width: 550px) {
    
    padding: 60px 10px 60px 10px;
    
    .list-wrapper {
      grid-template-columns: 1fr;
      justify-items: start;
    }

    .list-wrapper > ul {
      margin: 0;
      padding: 0 15px;
    }

    h2 {
      padding: 0 10px;
    }

    .imageCredit {
      width: 97%;
      font-size: 10px;
    }
  }
`;

export default function Clients() {
  return <Layout>
    <ClientStyles>
      <h2>Companies that have utilized our services include:</h2>
      <div className='list-wrapper'>
        <ul>
          <li>Aurora Corporation of America</li>
          <li>Now PrePay Corporation</li>
          <li>LPI Communications Group Inc.</li>
          <li>Tourism Richmond (B.C.)</li>
          <li>TIR Systems Inc.</li>
          <li>Sulzer Pumps (Canada) Inc.</li>
          <li>Zodiac Hurricane Technologies Inc.</li>
          <li>Modular Mining Systems Ltd.</li>
          <li>B.C. Liberal Party</li>
          <li>World Gaming, LLC</li>
          <li>ITI Canada Inc.</li>
          <li>Sonigistix</li>
          <li>Total Graphics Lithotech</li>
          <li>Power Measurement Ltd.</li>
          <li>Whistler/Backcomb</li>
          <li>Fieldstone Marketing & Communications Ltd.</li>
          <li>Translink</li>
        </ul>
        <ul>
          <li>Arc'teryx Marketing</li>
          <li>Art in Motion Ltd.</li>
          <li>Twist Marketing Inc.</li>
          <li>Future Shop</li>
          <li>SpeedPro Signs</li>
          <li>Sun Casinos, N.V.</li>
          <li>Tilano Decorative Products</li>
          <li>National Energy Corp.</li>
          <li>Big Image Inc.</li>
          <li>Speke Visual Communications Ltd.</li>
          <li>Essa Technologies Ltd.</li>
          <li>Marriott Pinnacle</li>
          <li>New Media Consulting Ltd.</li>
          <li>Ultracare Labs</li>
          <li>Endeavour Financial Corp.</li>
          <li>Silver Fox Studios</li>
          <li>La Touraine, Inc.</li>
        </ul>
      </div>
      <div className='imageCredit'>Background Image Credit: Arek Socha, Pixabay</div>
    </ClientStyles>
  </Layout>
}

